<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb"><span class="small">ABBREVIATIONS</span></a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>AB</td>
<td>Anchor Bible</td>
</tr>
<tr>
<td><i>ABD</i></td>
<td><i>Anchor Bible Dictionary.</i> Edited by David Noel Freedman. 6 vols. New York: Doubleday, 1992</td>
</tr>
<tr>
<td>ABRL</td>
<td>Anchor Bible Reference Library</td>
</tr>
<tr>
<td>AnBib</td>
<td>Analecta Biblica</td>
</tr>
<tr>
<td><i>ANF</i></td>
<td><i>Ante-Nicene Fathers</i></td>
</tr>
<tr>
<td><i>ANRW</i></td>
<td><i>Aufstieg und Niedergang der römischen Welt: Geschichte und Kultur Roms im Spiegel der neueren Forschung.</i> Part 2, <i>Principat.</i> Edited by Hildegard Temporini and Wolfgang Haase. Berlin: De Gruyter, 1972–</td>
</tr>
<tr>
<td><i>Bib</i></td>
<td><i>Biblica</i></td>
</tr>
<tr>
<td>BZNW</td>
<td>Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</td>
</tr>
<tr>
<td><i>CBQ</i></td>
<td><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td>ConBNT</td>
<td>Coniectanea Neotestamentica or Coniectanea Biblica: New Testament Series</td>
</tr>
<tr>
<td>FAT</td>
<td>Forschungen zum Alten Testament</td>
</tr>
<tr>
<td>FRLANT</td>
<td>Forschungen zur Religion und Literatur des Alten und Neuen Testament</td>
</tr>
<tr>
<td><i>HTR</i></td>
<td><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td>HTS</td>
<td>Harvard Theological Studies</td>
</tr>
<tr>
<td>Ign. <i>Eph.</i></td>
<td>Ignatius, <i>To the Ephesians</i></td>
</tr>
<tr>
<td>Ign. <i>Magn.</i></td>
<td>Ignatius, <i>To the Magnesians</i></td>
</tr>
<tr>
<td>Ign. <i>Phil.</i></td>
<td>Ignatius, <i>To the Philadelphians</i></td>
</tr>
<tr>
<td>Ign. <i>Pol.</i></td>
<td>Ignatius, <i>To Polycarp</i></td>
</tr>
<tr>
<td>Ign. <i>Rom.</i></td>
<td>Ignatius, <i>To the Romans</i></td>
</tr>
<tr>
<td>Ign. <i>Smyrn.</i></td>
<td>Ignatius, <i>To the Smyrnaeans</i></td>
</tr>
<tr>
<td><a id="page_xiv">Ign. <i>Trall.</i></a></td>
<td>Ignatius, <i>To the Trallians</i></td>
</tr>
<tr>
<td><i>JAAR</i></td>
<td><i>Journal of the American Academy of Religion</i></td>
</tr>
<tr>
<td><i>JBL</i></td>
<td><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td><i>JSNT</i></td>
<td><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td>JSNTSup</td>
<td>Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td><i>JTS</i></td>
<td><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td>LCL</td>
<td>Loeb Classical Library</td>
</tr>
<tr>
<td>LNTS</td>
<td>The Library of New Testament Studies</td>
</tr>
<tr>
<td>NABRE</td>
<td>New American Bible Revised Edition</td>
</tr>
<tr>
<td>NIGTC</td>
<td>New International Greek Testament Commentary</td>
</tr>
<tr>
<td><i>NovT</i></td>
<td><i>Novum Testamentum</i></td>
</tr>
<tr>
<td>NovTSup</td>
<td>Supplements to Novum Testamentum</td>
</tr>
<tr>
<td>NRSV</td>
<td>New Revised Standard Version</td>
</tr>
<tr>
<td><i>NTS</i></td>
<td><i>New Testament Studies</i></td>
</tr>
<tr>
<td>Pol. <i>Phil.</i></td>
<td>Polycarp, <i>To the Philippians</i></td>
</tr>
<tr>
<td>RSV</td>
<td>Revised Standard Version</td>
</tr>
<tr>
<td>SBLDS</td>
<td>Society of Biblical Literature Dissertation Series</td>
</tr>
<tr>
<td>SBLSBS</td>
<td>Society of Biblical Literature Sources for Biblical Study</td>
</tr>
<tr>
<td>SCS</td>
<td>Septuagint and Cognate Studies</td>
</tr>
<tr>
<td>SP</td>
<td>Sacra Pagina</td>
</tr>
<tr>
<td>StPB</td>
<td>Studia Post-biblica</td>
</tr>
<tr>
<td>SUNT</td>
<td>Studien zur Umwelt des Neuen Testaments</td>
</tr>
<tr>
<td>SVTP</td>
<td>Studia in Veteris Testamenti Pseudepigraphica</td>
</tr>
<tr>
<td><i>TBT</i></td>
<td><i>The Bible Today</i></td>
</tr>
<tr>
<td><i>TDNT</i></td>
<td><i>Theological Dictionary of the New Testament</i>. Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–76</td>
</tr>
<tr>
<td>WBC</td>
<td>Word Biblical Commentary</td>
</tr>
<tr>
<td>WUNT</td>
<td>Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td><i>ZNW</i></td>
<td><i>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?5c0566b2